import React from "react";
import { StyledButton, StyledHCard, StyledService } from "../components/Styles";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { slugs } from "../config/slugs";
import Consultation from "../components/Consultation";

// Hero image
import img12 from "../components/Styles/assets/img12.webp";

// Advantages icons
import Satisfaction from "../components/Styles/assets/Graphics/Satisfaction.webp";
import ConversionRates from "../components/Styles/assets/Graphics/ConversionRates.webp";
import Accessibility2 from "../components/Styles/assets/Graphics/Accessibility2.webp";
import Brand from "../components/Styles/assets/Graphics/Brand.webp";
import ReducedCosts from "../components/Styles/assets/Graphics/ReducedCosts.webp";
import Compatibility from "../components/Styles/assets/Graphics/Compatibility.webp";
import Retention from "../components/Styles/assets/Graphics/Retention.webp";

function Uiux() {
  const { t, i18n } = useTranslation();

  // Map advantages with icons
  const advantages = [
    { key: "satisfaction", icon: Satisfaction },
    { key: "conversionRates", icon: ConversionRates },
    { key: "accessibility", icon: Accessibility2 },
    { key: "brand", icon: Brand },
    { key: "reducedCosts", icon: ReducedCosts },
    { key: "compatibility", icon: Compatibility },
    { key: "retention", icon: Retention },
  ];

  return (
    <StyledService.Container>
      {/* ================= HERO ================= */}
      <StyledService.Hero>
        <StyledService.Content>
          <StyledService.Title lang={i18n.language}>{t("uiux.title")}</StyledService.Title>
          <StyledService.Description>{t("uiux.description")}</StyledService.Description>

          <Link to={`/${i18n.language}/${slugs.contact[i18n.language]}`}>
            <StyledButton.Main>{t("uiux.cta")}</StyledButton.Main>
          </Link>
        </StyledService.Content>

        <StyledService.ImageContainer>
          <img
            src={img12}
            alt={t("uiux.title")}
            style={{ width: "100%", height: "auto", borderRadius: "10px" }}
          />
        </StyledService.ImageContainer>
      </StyledService.Hero>

      <Consultation />

      {/* ================= ADVANTAGES ================= */}
      <StyledService.H3 lang={i18n.language}>{t("uiux.advantagesTitle")}</StyledService.H3>

      <StyledHCard.Container>
        {advantages.map(({ key, icon }) => (
          <StyledHCard.SingleCard key={key}>
            <StyledHCard.IconContainer>
              <img src={icon} alt={key} />
            </StyledHCard.IconContainer>

            <StyledHCard.Content>
              <StyledHCard.Title>{t(`uiux.advantages.${key}.title`)}</StyledHCard.Title>
              <StyledHCard.Description>{t(`uiux.advantages.${key}.desc`)}</StyledHCard.Description>
            </StyledHCard.Content>
          </StyledHCard.SingleCard>
        ))}
      </StyledHCard.Container>

      <Consultation />
    </StyledService.Container>
  );
}

export default Uiux;